import { render, staticRenderFns } from "./QuotationHeader.vue?vue&type=template&id=8022812e"
import script from "./QuotationHeader.vue?vue&type=script&lang=ts"
export * from "./QuotationHeader.vue?vue&type=script&lang=ts"
import style0 from "./QuotationHeader.vue?vue&type=style&index=0&id=8022812e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports